import * as R from 'ramda'

/**
 * @param {object[]} persons
 * @param {boolean} is_user
 */
export function filter_by_is_user(persons, is_user = true) {
    return R.cond([
        [ R.equals(true),  () => R.filter(person => !R.isNil(person.user))(persons) ],
        [ R.equals(false), () => R.filter(person => R.isNil(person.user))(persons) ],
        [ R.T,             R.always(persons)]
    ])(is_user)
}

/**
 * @param {object[]} models
 * @param {number} id
 * @return {number|undefined}
 */
export const find_by_id = R.curry((models, id) => {
    return R.find(R.propEq('id', id), models)
})

/**
 * @param {object[]} users
 * @param {object[]} persons
 * @param {number} id
 * @return {object|undefined}
 */
export function find_by_user_id(users, persons, id) {
    return R.compose(

        // Person finden
        find_by_id(persons),

        // `person`-Property von Benutzer lesen
        R.prop('person'),

        // Benutzer finden
        R.find(R.propEq('id', id))

    )(users)
}

/**
 * @param {object} person
 */
export function full_name(person) {
    return R.cond([
        [R.isNil, R.always('')],
        [R.T,     model => `${model.firstName} ${model.lastName}`]
    ])(person)
}
